<template>
  <div>
    <delete-modal :yesFunc="deleteCandidate" ref="deleteModalRef" />

    <!-- Aday Listesi -->
    <v-card style="border-radius: 10px">
      <v-card-title>
        <v-row align="center">
          <v-btn elevation="0" icon color="default" @click="goBack()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <v-col>Seçim Detayı</v-col>

          <v-spacer />

          <v-btn color="info" outlined @click="openCandidateForm">
            Aday Ekle
          </v-btn>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-data-table
          :no-data-text="$t('description.noList')"
          :headers="headers"
          :items="candidates"
          :loading="$store.state.loadingStatus"
        >
          <template v-slot:item.PhotoFileId="{ item }">
            <v-avatar v-if="item.PhotoFileId" size="36">
              <v-img :src="getImageURL(item.PhotoFileId)"/>
            </v-avatar>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn icon @click="updateItem(item)">
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="openDeleteModal(item.Id)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- 🔥 Seçim Sonuçları -->
    <v-card class="mt-4" style="border-radius: 10px">
      <v-card-title>Seçim Sonuçları</v-card-title>

      <v-divider />

      <v-card-text>
        <div v-if="results.length === 0">
          Sonuç bulunamadı.
        </div>

        <v-row v-else>
          <v-col
            cols="12"
            v-for="(item, index) in sortedResults"
            :key="item.Id"
          >
            <v-card outlined class="pa-3">
              <v-row align="center">
                
                <!-- Foto -->
                <v-col cols="2">
                  <v-avatar size="50">
                    <v-img :src="getImageURL(item.PhotoFileId)" />
                  </v-avatar>
                </v-col>

                <!-- İsim -->
                <v-col cols="6">
                  <div style="font-weight: 600">
                    {{ item.Name }}
                    <v-chip
                      v-if="index === 0 && item.VoteCount > 0"
                      small
                      color="success"
                      text-color="white"
                      class="ml-2"
                    >
                      Lider
                    </v-chip>
                  </div>

                  <div style="font-size: 12px; color: gray">
                    Oy: {{ item.VoteCount }}
                  </div>
                </v-col>

                <!-- Progress -->
                <v-col cols="4">
                  <v-progress-linear
                    :value="getVotePercentage(item.VoteCount)"
                    height="10"
                    color="success"
                    rounded
                  />

                  <div style="font-size: 12px; text-align: right">
                    %{{ getVotePercentage(item.VoteCount).toFixed(0) }}
                  </div>
                </v-col>

              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Aday Ekle Dialog -->
    <v-dialog v-model="candidateFormDialog" max-width="600">
      <v-card>
        <v-card-title>Aday Ekle</v-card-title>

        <v-card-text>
          <CandidateForm
            v-if="candidateFormDialog"
            :isUpdate="isUpdate"
            :initialForm="form"
            ref="candidateForm"
            @save="saveCandidate"
            @cancel="candidateFormDialog = false;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CandidateForm from "../components/CandidateForm.vue";
import ElectionsService from "../services/ElectionsService";
import FileService from "../services/FileService";
import DeleteModal from "../components/General/DeleteModal";

export default {
  components: { CandidateForm, DeleteModal },

  data() {
    return {
      form: {},
      isUpdate: false,

      candidates: [],
      results: [],

      headers: [
        { text: "Fotoğraf", value: "PhotoFileId" },
        { text: "Ad Soyad", value: "Name" },
        { text: "İşlemler", value: "actions", sortable: false },
      ],

      candidateFormDialog: false,

      deleteId: null,
    };
  },

  mounted() {
    const electionId = this.$route.params.id;

    this.fetchCandidates();

    this.fetchResults(electionId);
  },

  computed: {
    sortedResults() {
      return [...this.results].sort(
        (a, b) => b.VoteCount - a.VoteCount
      );
    },
  },

  watch: {
    candidateFormDialog(newValue){
      if(!newValue){
        this.form = null;
        this.isUpdate = false;
      }
    }
  },

  methods: {
    updateItem(item){
      this.isUpdate = true;
      this.form = Object.assign({}, item);
      this.candidateFormDialog = true;
    },

    goBack() {
      this.$router.go(-1);
    },

    getImageURL(fileId) {
      if (!fileId)
        return "https://tcap.pbworks.com/f/1435170280/myAvatar.png";

      return FileService.getFileString(fileId);
    },

    fetchCandidates() {
      const electionId = this.$route.params.id;

      this.$store.state.loadingStatus = true;

      ElectionsService.getCandidates(electionId)
        .then((res) => {
          this.candidates = res.data.Data;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    fetchResults(electionId) {
      ElectionsService.getResults(electionId)
        .then((res) => {
          this.results = res.data.Data || [];
        })
        .catch(window.showError);
    },

    getTotalVotes() {
      return this.results.reduce(
        (sum, r) => sum + r.VoteCount,
        0
      );
    },

    getVotePercentage(vote) {
      const total = this.getTotalVotes();
      if (!total) return 0;
      return (vote / total) * 100;
    },

    openCandidateForm() {
      this.candidateFormDialog = true;
    },

    async saveCandidate({ candidate, isUpdate }) {
      this.$store.state.loadingStatus = true;
      const electionId = this.$route.params.id;
      const { Photo, Name = "", Username = "", Biography = "", ...others } = candidate || {};

      const payload = {
        ...others,
        ElectionId: Number(electionId),
      };

      try{
        let photoId = candidate?.PhotoFileId;
        
        if(Photo){
          const formData = new FormData();
          formData.append("Files", Photo);
          formData.append("Type", 1);

          const { data } = await FileService.uploadFile(formData);
          if (Array.isArray(data) && data.length > 0) {
            photoId = data[0]?.Id;
          }
        }
        
        if (photoId) {
          const body = {
            ElectionId: Number(electionId),
            Name,
            Username,
            Biography,
            PhotoFileId: photoId
          };

          if(isUpdate){
            body['Id'] = candidate?.Id;
          }

          await ElectionsService[`${isUpdate ? 'update' : 'add'}Candidate`](body)

          this.fetchCandidates();
          this.fetchResults(electionId);

          this.candidateFormDialog = false;

          window.showSuccess?.("Aday başarıyla eklendi.");

          this.$refs.candidateForm?.$refs.observer?.reset();
        }
      }
      catch(error){
        window.showError(error)
      }
      finally{
        this.$store.state.loadingStatus = false;
      }
    },

    openDeleteModal(id) {
      this.deleteId = id;
      this.$refs.deleteModalRef.modalStatus = true;
    },

    deleteCandidate() {
      this.$store.state.loadingStatus = true;

      ElectionsService.deleteCandidate(this.deleteId)
        .then(() => {
          window.showSuccess(
            "Başarılı",
            "Aday kaldırıldı."
          );

          this.fetchCandidates();
          this.fetchResults(this.$route.params.id);

          this.$refs.deleteModalRef.modalStatus = false;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
  },
};
</script>